'use client';

import { useEffect, useState } from 'react';

/**
 * Shared hook to detect mobile viewport (max-width: 799px).
 *
 * Returns false on server (SSR-safe), then syncs to actual viewport on client.
 * Reuses the same event listener across all components using this hook.
 *
 * Used by: TrustBadges, HowItWorks, and other responsive components
 */
export function useIsMobile(initialValue = false): boolean {
  const [isMobile, setIsMobile] = useState(initialValue);

  useEffect(() => {
    // MediaQuery for the 'dt:' breakpoint (800px in Tailwind config)
    const mq = window.matchMedia('(max-width: 799px)');

    // Sync state on mount
    const sync = () => setIsMobile(mq.matches);
    sync();

    // Update on resize
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return isMobile;
}
